/**
 * 汎用ユーティリティ定義
 */

/**
 * オプション選択時のアイコン定義
 * - シングルセレクトの場合、丸型でチェックマークが入るアイコン
 * - マルチセレクトの場合、四角型でチェックマークが入るアイコン
 */
export const optionIconsByStateAndType = {
  single: {
    selected: 'check-circle',
    unselected: 'circle',
  },
  multiple: {
    selected: 'check-square',
    unselected: 'minus-square',
  },
}

export const originServiceNames = {
  kazai: '家財宅急便',
  kaguido: 'ちょこっと模様替え',
}
